// Module
var code = "<li class=\"landing-page-carousel-item tw-flex tw-items-center tw-justify-center\n    tw-absolute tw-list-reset w-text-center tw-pin-x\" ng-transclude></li>\n";
// Exports
module.exports = code;